export const screens = {
  phablet: '375px',
  tablet: '768px',
  desktop: '1024px',
  'desktop-l': '1440px',
  'desktop-xl': '1920px'
}
